import NextHead from 'next/head'

interface HeadProps {
  title?: string
  description?: string
  imageSrc?: string
  imageWidth?: number
  imageHeight?: number
  children?: React.ReactNode
}

export default function Meta({
  title,
  description,
  imageSrc,
  imageWidth,
  imageHeight,
  children,
}: HeadProps) {
  return (
    <NextHead>
      {title && (
        <>
          <title>{title}</title>
          <meta name='twitter:title' content={title} />
          <meta property='og:title' content={title} />
        </>
      )}

      {description && (
        <>
          <meta name='description' content={description} />
          <meta name='twitter:description' content={description} />
          <meta property='og:description' content={description} />
        </>
      )}

      {imageSrc && (
        <>
          <meta name='image' content={imageSrc} />
          <meta name='twitter:image' content={imageSrc} />
          <meta property='og:image' content={imageSrc} />
          <meta name='twitter:card' content='summary_large_image' />
          {typeof imageWidth === 'number' && (
            <meta property='og:image:width' content={imageWidth.toString()} />
          )}
          {typeof imageHeight === 'number' && (
            <meta property='og:image:height' content={imageHeight.toString()} />
          )}
        </>
      )}

      {/* props.children must be at the end so users can override everything */}
      {children}
    </NextHead>
  )
}
